/**
 * 最新活动
 * Created at 2021-10-03 00:26
 * @author teapot
 */
import { Image, List, Pagination } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import Api from "../../api";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import HeadView from "../../components/head/HeadView";
import Config from "../../config";
import { DetailsParams } from "../../model/HomeModel";
import { activityAsync, setActivityCurrent } from "../../store/OtherStore";
import "./index.css";
import ReportAddress from "./ReportAddress";
const Report = () => {
  const {
    activityCurrent,
    activityList,
    activityPic,
    activityTitle,
    activityTotal,
  } = useAppSelector((state: RootState) => {
    return state.other;
  });

  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(activityAsync({ page: activityCurrent, category: 0, time: 0 }));
  }, [activityCurrent, dispatch]);
  return (
    <div className="report">
      <ReportAddress></ReportAddress>
      {/* <div className="line"></div> */}
      <HeadView
        title={activityTitle}
        imgs={`${Config.MAIN_URL}${activityPic}`}
      />

      <List
        className="report-list"
        dataSource={activityList}
        locale={{ emptyText: t("nodata") }}
        // footer={() => {
        //   return <Pagination defaultCurrent={activityCurrent} total={activityTotal} />;
        // }}
        renderItem={(item, index) => {
          const reg = /style\s*?=\s*?(['"])[\s\S]*?\1/;
          const content = item.content ? item.content.replace(reg, "") : "";
          return (
            <List.Item
              className="report-item report-item-phone"
              onClick={() => {
                // if (index === 0) {
                //   history.push(
                //     "http://hknegrc.com/newsroom/press-release/date_activity/CMZPePnYpuxeBDGY8"
                //   );
                //   console.log("====================================");
                //   console.log("????");
                //   console.log("====================================");
                // }
                // history.push("/newsroom/press-release/date_activity", {
                //   url: Api.activity_details,
                //   uuid: item.uuid,
                //   methods: "get",
                //   video: item.video,
                // } as DetailsParams);
                let path = window.btoa(
                  JSON.stringify({
                    url: Api.activity_details,
                    uuid: item.uuid,
                    methods: "get",
                    video: item.video,
                  })
                );
                history.push(`/newsroom/press-release/date_activity/${path}`, {
                  url: Api.activity_details,
                  uuid: item.uuid,
                  methods: "get",
                  video: item.video,
                });
              }}
            >
              <Image
                className={"report-item-image"}
                src={`${Config.MAIN_URL}${item.img}`}
                preview={false}
              />
              <div className="report-item-right report-item-right-left phone-center">
                {/* <div
                  className='report-placeholder tinktank-item-middle-content tinktank-item-middle-content-phone'
                  dangerouslySetInnerHTML={{ __html: content }}
                /> */}
                <div className="news-item-image-titlex news-item-image-title-phone iphone13">
                  {" "}
                  {item.title}{" "}
                </div>{" "}
                <div className="report-quality">
                  <span className="quality-left quality-common report-item-title ">
                    {item.quality}
                  </span>{" "}
                  <span className="quality-right quality-common phone-padding">
                    {item.time}
                  </span>
                </div>
              </div>
            </List.Item>
          );
        }}
      />

      <div className="report-pagination">
        <Pagination
          style={{ marginTop: "10px" }}
          defaultCurrent={1}
          current={activityCurrent}
          total={activityTotal}
          pageSize={9}
          onChange={(page) => {
            dispatch(setActivityCurrent(page));
            dispatch(activityAsync({ page, category: 0, time: 0 }));
          }}
          hideOnSinglePage={true}
        />
      </div>
    </div>
  );
};

export default Report;
